import { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}

export const Badge = ({ children, variant = 'secondary', className = '' }: BadgeProps) => {
  const variantClass = variant === 'primary' ? 'badge-primary' : 'badge-secondary';
  return (
    <span className={`${variantClass} ${className}`}>
      {children}
    </span>
  );
};
